<template>
  <div id="notifier" v-if="!isEmpty">
    <ul>
      <transition-group name="notification">
        <li v-for="item in getNotifications" :key="item.id" :class="item.type">
          <div class="icon"><font-awesome-icon :icon="item.type in meta.icons ? meta.icons[item.type] : ['fal', 'square-full']" :spin="meta.spins.includes(item.type)"/></div>
          <div class="content">
            <span class="title body-1">{{ item.title }}</span>
            <span class="message caption">{{ item.message }}</span>
            <div class="prog-wrap" v-if="item.progress">
              <span class="empty-bar">&nbsp;</span>
              <span class="filled-bar"
                :style="{width: (item.progress * 100) + '%'}">&nbsp;</span>
            </div>
          </div>
          <div class="coms" v-if="item.coms">
          </div>
          <button class="closer"
            @click.stop="close(item.id)"><font-awesome-icon :icon="['fal', 'times-circle']" /></button>
        </li>
      </transition-group>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'notifier',
  data () {
    return {
      config: {
      },
      meta: {
        icons: {
          message: ['fal', 'bell'],
          alert: ['fal', 'exclamation-triangle'],
          progress: ['fal', 'spinner-third']
        },
        spins: [
          'progress'
        ]
      },
      store: {
        notifications: {}
      }
    }
  },
  methods: {
    close: function (id) {
      this.$store.commit('notifier/close', id)
    }
  },
  computed: {
    isEmpty () {
      return (this.store.notifications.length === 0)
    },
    getNotifications () {
      return this.$store.getters['notifier/list']()
    }
  }
}
</script>

<style lang="scss">
#notifier {
  position: fixed;
  top: $header_h;
  right: 0;
  z-index: 999;
  ul {
    padding: 1rem 2rem 1rem 0;
    li {
      position: relative;
      display: flex;
      width: $notifyer_w;
      height: $notifyer_h;
      font-size: 1rem;
      background: $mb_c;
      box-shadow: $float;
      border-radius: .2rem;
      margin-bottom: 1rem;
      .icon {
        flex: 0 0 auto;
        min-width: $notifyer_icon_w;
        height: $notifyer_h;
        line-height: $notifyer_h;
        font-size: 2.8rem;
      }
      .content {
        flex: 1 0;
        padding: 1rem;
        span {
          display: block;
          width: 100%;
          text-align: left;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          &.title {
            font-size: 1.2em;
            font-weight: bold;
            margin-bottom: .2rem;
          }
        }
        .prog-wrap {
          position: relative;
          width: 100%;
          margin-top: .4rem;
          .empty-bar {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: .6em;
            background: rgba(#000, .2);
          }
          .filled-bar {
            position: absolute;
            top: 0;
            left: 0;
            height: .6em;
            background: $s_c;
          }
        }
      }
      .coms {
        flex: 0 0 auto;
        min-width: $notifyer_com_w;
      }
      .closer {
        position: absolute;
        top: .4rem;
        right: .4rem;
        font-size: 1.2em;
        &:hover {
          color: $s_c;
        }
      }
      &.alert {
        .icon {
          svg {
            color: $waf_c;
          }
        }
      }
    }
  }
}

.notification-enter {
  opacity: 0;
}
.notification-enter-active {
  animation: fadeInRight .5s;
}
.notification-leave-active {
  opacity: 0;
}
.notification-leave-active {
  animation: fadeOutRight .5s;
}
@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
@keyframes fadeOutRight {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }
}

</style>
